<template>
    <vs-popup :active.sync="isActive" v-esc="escape"
              :title="'Şube Bazlı Fiyat Düzenleme'">
      <div class="mt-6 flex items-center justify-between px-6">
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
        <div class="px-6 pt-6" @keyup.enter="submitData">
  
            <vs-row vs-type="flex" vs-w="12" class="mb-2">
        <vs-col vs-type="flex" vs-w="12" vs-align="center">
          <v-select v-model="selectedBranch" itemid="id" label="name" class="w-full" v-if="$isCenterBranch()"
            placeholder="Liste Seçimi.." :options="$currentUser.branch.id == 1 ? lists : []" :clearable="false">
          </v-select>
        </vs-col>
      </vs-row>
          
  
          <vs-input  id="price" name="Satış Fiyatı" v-validate="'required'"
                    v-model="product" class="w-full" label-placeholder="Satış Fiyatı"/>
        </div>
        <div class="flex mt-5 px-6 pb-4">
          <vs-button class="mr-auto" type="gradient" color="danger"
                     @click="newVariant = {},isActive = false;rootName = null;">
            Vazgeç
          </vs-button>
          <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
        </div>
      </VuePerfectScrollbar>
    </vs-popup>
  </template>
  
  <script>
  import {
    getBranchProductPrice,
    setBranchProductPrice,
    getBranchProductPriceLists
  } from "@/api/BranchProductPrice.js";
  import {
    getBranchNameList2
  } from "@/api/Branch";
  
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import VariantsStateTypes from "@/model/constants/VariantsStateTypes";
  
  export default {
    data() {
      return {
        variantTypes: [{
          id: "Group",
          name: "Group"
        },
          {
            id: "Variant",
            name: "Variant"
          }
        ],
        sizes: [],
        deleteId: null,
        rootName: null,
        product: 0,
        lists: [],
        isActive: false,
        newPrice:{},
        selectedBranch: null,
        branch:{},
        recipes: [],
        newVariant: {},
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60
        }
      };
    },
    methods: {
      escape() {
        if (this.isActive == true) this.isActive = false;
      },
      
      getBranches() {
      getUnitNameList()
        .then((res) => {
          if (res && res.status == 200) {
            this.units = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Birim Listesi Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getBranchProductPrice() {
        getBranchProductPrice(this.newPrice.id,this.branch.id).then(res => {
          if (res && res.status == 200) {
            this.product = res.data;
          } else if (res.status==204) {
            this.product = res.data;
} else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şube ürünü getirilemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll();
        if (checker) {
            this.newVariant.price =  parseFloat(this.product);
            this.newVariant.productId = parseFloat(this.newPrice.id)
            this.newVariant.branchProductPriceListId= parseFloat(this.branch.id)
            setBranchProductPrice(this.newVariant).then(res => {
            if (res.data==true && res.status == 200) {
              this.newVariant = {};
              this.$vs.notify({
                color: "success",
                title: "Başarılı",
                text: "Fiyat Güncelleme Başarılı"
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Varyant Güncelleme Başarısız !"
              });
            }
          })
        }
      }
    },
    components: {
      VuePerfectScrollbar
    },
    watch: {
        selectedBranch(val) {
        if (val) {
            this.branch=val
          this.product = {};
          this.getBranchProductPrice();
        }
      },
      deleteId: function (val) {
        if (val) deleteProduct(val).then(res => {
          if (res && res.status === 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Varyant Silme Başarılı !"
            });
            this.deleteId = null;
            this.$emit("reloadTree");
          } else {
            this.$vs.notify({
              color: "success",
              title: "Hata : " + res.status,
              text: "Varyant Silme Başarısız !"
            });
          }
        }).catch(err => {
          this.$vs.notify({
            color: "success",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası"
          });
        });
      },
      isActive: function (val) {
        if (!val) return;
        if (Object.entries(this.newVariant).length === 1) {
          this.$validator.reset();
        } else {
  
          if (this.newVariant.children != null && this.newVariant.children.length > 0) {
  
            this.newVariant.children.forEach(item => item.state = VariantsStateTypes.Unchanged);
          }
        }
      }
    },
    mounted: function () {
  
    },
    created: async function () {
      this.lists = await getBranchProductPriceLists();
    }
  };
  
  </script>
  
  <style lang="scss" scoped>
  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: absolute !important;
  }
  
  .style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: red;
    text-transform: lowercase;
    font-variant: small-caps;
  }
  
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }
  
    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
  
      .img-upload {
        margin-top: 2rem;
  
        .con-img-upload {
          padding: 0;
        }
  
        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
  
  .tabPager {
    background-color: darkgreen;
    border-radius: 50%;
  }
  
  </style>
  